import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient) {
  }

  searchApi(text) {
    return this.http.get(environment.url+`api/autocomplete?focus.point.lat=0&focus.point.lon=0&api-version=1.1&apikey=${environment.apikey2}&text=${text}`);

  }
  getDetailSmartCode(code) {
    return this.http.get( environment.url+`api/autocomplete?text=${code}&apikey=${environment.apikey2}&api-version=1.1` );
  }
  getSmartCode(lat,lng){
    return this.http.get(`https://maps.vnpost.vn/api/reverse?point.lat=${lat}&point.lon=${lng}&api-version=1.1&apikey=${environment.apikey2}`)
  }
  getCategory():Observable<any>{
    return this.http.get(environment.urlTemp+'vpost/master-data/get-category')
  }

}
